import { config } from "@/config";
export class ComprasService {
    static getHeaders(isFormData = false) {
        const headers = {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        };
        if (!isFormData) {
            headers["Content-Type"] = "application/json";
        }
        return headers;
    }
    // --- Orden de Pedido (Fase 1) ---
    static async getOrdenes() {
        const response = await fetch(`${config.API_URL}/api/OrdenPedidoProveedor`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener las órdenes de pedido");
        return response.json();
    }
    static async getOrdenById(id) {
        const response = await fetch(`${config.API_URL}/api/OrdenPedidoProveedor/${id}`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener la orden");
        return response.json();
    }
    static async createOrdenDesdeCsv(ordenDto) {
        const response = await fetch(`${config.API_URL}/api/OrdenPedidoProveedor/csv`, {
            method: "POST",
            headers: this.getHeaders(),
            body: JSON.stringify(ordenDto),
        });
        if (!response.ok)
            throw new Error("Error al procesar la orden del CSV");
        return response.json();
    }
    static async deleteOrden(id) {
        const response = await fetch(`${config.API_URL}/api/OrdenPedidoProveedor/${id}`, {
            method: "DELETE",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al eliminar la orden");
        return response.json();
    }
    // --- Ingreso de Compra (Fases 2, 3, 4) ---
    static async getIngresos() {
        const response = await fetch(`${config.API_URL}/api/IngresoCompra`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener ingresos");
        return response.json();
    }
    static async getIngresoById(id) {
        const response = await fetch(`${config.API_URL}/api/IngresoCompra/${id}`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener el ingreso");
        return response.json();
    }
    static async createIngreso(ingresoDto) {
        const isFormData = ingresoDto instanceof FormData;
        const response = await fetch(`${config.API_URL}/api/IngresoCompra`, {
            method: "POST",
            headers: this.getHeaders(isFormData),
            body: isFormData ? ingresoDto : JSON.stringify(ingresoDto),
        });
        if (!response.ok)
            throw new Error("Error al registrar el ingreso");
        return response.json();
    }
    static async updateIngreso(id, ingresoDto) {
        const response = await fetch(`${config.API_URL}/api/IngresoCompra/${id}`, {
            method: "PUT",
            headers: this.getHeaders(),
            body: JSON.stringify(ingresoDto),
        });
        if (!response.ok)
            throw new Error("Error al pre-salvar/actualizar ingreso");
        return response.json();
    }
    static async aprobarIngreso(id) {
        const response = await fetch(`${config.API_URL}/api/IngresoCompra/${id}/aprobar`, {
            method: "PUT",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al totalizar/aprobar el ingreso");
        return response.json();
    }
    static async transferir(id, almacenId = 1) {
        const response = await fetch(`${config.API_URL}/api/IngresoCompra/${id}/transferir?almacenId=${almacenId}`, {
            method: "PUT",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al transferir al inventario");
        return response.json();
    }
    static async anularIngreso(id) {
        const response = await fetch(`${config.API_URL}/api/IngresoCompra/${id}`, {
            method: "DELETE",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al anular ingreso");
        return response.json();
    }
}
